import Swiper from '@src/components/swiper';
import { ScreensInt } from '@tailwindConfig/screens.config';

export const ratingVariationSwiper = () => {
  new Swiper('.swiper-testimonials', {
    // Default parameters
    slidesPerView: 'auto',
    watchOverflow: true,
    speed: 600,
    autoplay: {
      delay: 8000,
    },
    breakpoints: {
      1: { // when window width is >= 1px
        spaceBetween: -10
      },
      [ScreensInt.md]: { // when window width is >= md px
        spaceBetween: 800
      }
    },
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination-testimonials',
      clickable: true
    }
  });
  const testimonialsSection = document.querySelector('.testimonials-section');

  if (testimonialsSection.querySelector('.swiper-testimonials').querySelectorAll(".swiper-slide").length == 1) {
    if (testimonialsSection.querySelector('.swiper-testimonials').querySelector('.swiper-pagination')) {
      testimonialsSection.querySelector('.swiper-testimonials').querySelector('.swiper-pagination').style.display = "none";
    } else {
      testimonialsSection.querySelector('.md-arrows').style.display = "none";
    }
  }

  if (window.matchMedia(`(max-width: ${ScreensInt.md - 1}px)`).matches && testimonialsSection) {
    const clientName = testimonialsSection.querySelectorAll('.client-name');
    if (clientName) {
      clientName.forEach(el => {
        el.innerText = el.innerText.replace(" —", ",");
      })
    }
  }
};

